var _a;
import * as checkModule from 'check-types';
const checkBase = ((_a = checkModule.default) !== null && _a !== void 0 ? _a : checkModule);
function getJson(context) {
    try {
        return JSON.stringify(context);
    }
    catch (err) {
        return ('{' +
            Object.keys(context)
                .map((key) => key + ': ' + context[key])
                .join(', ') +
            '}');
    }
}
const makeFailer = function (typeCheck, msg) {
    return function (x, name, context) {
        if (!typeCheck(x)) {
            const xtraMessage = (() => {
                if (!context) {
                    return '';
                }
                const contextValue = typeof context === 'function' ? context() : context;
                return ', context:' + getJson(contextValue);
            })();
            throw new Error('Expected variable ' +
                (name ? name : 'UNKNOWN') +
                ' to be of type ' +
                msg +
                " but found type '" +
                (x ? x.constructor.name : 'undefined') +
                "' and value: " +
                (x ? JSON.stringify(x) : 'undefined') +
                xtraMessage);
        }
    };
};
const checkInstance = function (prototype) {
    const checker = function (obj) {
        return obj.constructor === prototype;
    };
    return checker;
};
checkBase.number.orFail = makeFailer(checkBase.number, 'number');
checkBase.function.orFail = makeFailer(checkBase.function, 'function');
checkBase.boolean.orFail = makeFailer(checkBase.boolean, 'bool');
checkBase.string.orFail = makeFailer(checkBase.string, 'string');
checkBase.object.orFail = makeFailer(checkBase.object, 'object');
checkBase.date.orFail = makeFailer(checkBase.date, 'date');
checkBase.array.of.object.orFail = makeFailer(checkBase.array.of.object, 'array.of.object');
checkBase.array.of.number.orFail = makeFailer(checkBase.array.of.number, 'array.of.number');
checkBase.array.of.string.orFail = makeFailer(checkBase.array.of.string, 'array.of.string');
checkBase.array.orFail = makeFailer(checkBase.array, 'array');
checkBase.undefined.orFail = makeFailer((x) => x === undefined, 'undefined');
export const instanceOfOrFail = function (prototype) {
    return {
        orFail: makeFailer(checkInstance(prototype), prototype.name),
    };
};
const check = new Proxy(checkBase, {
    get(target, property, receiver) {
        if (property === 'instanceOfOrFail') {
            return instanceOfOrFail;
        }
        return Reflect.get(target, property, receiver);
    },
});
export default check;
